const React = require('react');
const ReactIntl = require('react-intl');
const {Input,SelectNative,SelectOption,Layout} = require("@metro-ui/core");
const defaultMessages = require('../../i18n/messages/default');
const PhonePrefixes = require("../../constants/PhonePrefixes").default;
const UrlUtils = require('../../utils/urlUtils');

const defaultPhoneNumberLanguage = require("../../constants/AppConstants").DEFAULT_PHONE_NUMBER_LANGUAGE;
const country_code= UrlUtils.getParameterByName("country_code");
const numberDetails = PhonePrefixes.find((el) => el.key === country_code);
const phoneNumberValue = numberDetails ? numberDetails : PhonePrefixes.find((el) => el.key === defaultPhoneNumberLanguage);

const { injectIntl } = ReactIntl;
 
class PhoneNumber extends React.Component {
    constructor(props) {
      super(props);
  
      this.state = {
        mobileNumber: "",
        prefix: phoneNumberValue.label || "",
        numberInfo: phoneNumberValue.info,
        phonePrefixes: _.sortBy(_.uniqBy(PhonePrefixes, "label"),"label","asc"),
      };

      this.storeMobileNumber = this.storeMobileNumber.bind(this);
      this.handlePrefixChange = this.handlePrefixChange.bind(this);
    }

    storeMobileNumber(ev, value) {
        this.setState({ mobileNumber: value });
        this.props.storeMobileNumber(ev,value);
    }
    
    handlePrefixChange(_, value) {
        const prefixDetails =
            this.state.phonePrefixes.find((el) => el.label === value) || {};
        if (prefixDetails.info) {
            this.setState({ numberInfo: prefixDetails.info });
        }
        this.setState({ prefix: value });
        this.props.handlePrefixChange(_,value)
    }

    render(){
        const countryLabel = this.props.intl.formatMessage(
            defaultMessages["loginpreferences.2famethods.codes_via_sms.country_code"]);
        
        const phoneLabel = this.props.intl.formatMessage(
            defaultMessages["loginpreferences.2famethods.codes_via_sms.mobile_number"]) + "*";

        return(
            <>
                <div style={{ width: '100px' }}>
                    <SelectNative
                        id="phone-prefix"
                        name="phone-prefix"
                        className="select-prefix"
                        label={countryLabel}
                        value={this.state.prefix}
                        onChange={this.handlePrefixChange}
                    >
                        {this.state.phonePrefixes.map((el) => (
                        <SelectOption value={el.label}>{el.label}</SelectOption>
                        ))}
                    </SelectNative>
                </div>
                <div style={{flexGrow: "2"}}>
                <Input
                    type="number"
                    className="form-controls mobile-input"
                    placeholder={this.state.numberInfo}
                    label={phoneLabel}
                    value={this.state.mobileNumber}
                    onChange={this.storeMobileNumber}
                    isRequired
                />
                </div>
            </>
        );
    }
}

module.exports = injectIntl(PhoneNumber);